import { useLingui } from "@lingui/react";
import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";

const KEY_POLOTNO_TEMPLATE = "polotno.template";

export const useQueryPolotnoTemplate = (
  params: Parameters<typeof ApiSmpArtGallery.Polotno.template>[0],
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.Polotno.template>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    i18n: { locale },
  } = useLingui();

  params = {
    ...params,
    text_lang: locale,
  };

  return useQuery<Await<ReturnType<typeof ApiSmpArtGallery.Polotno.template>>>(
    [KEY_POLOTNO_TEMPLATE, params],
    () => ApiSmpArtGallery.Polotno.template(params),
    {
      ...options,
      enabled: !!params.id && options?.enabled,
    },
  );
};

useQueryPolotnoTemplate.KEY = KEY_POLOTNO_TEMPLATE;
